'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ENABLE_DEBUG_TOOLS = exports.ENABLE_DEBUG_TOOLS = 'ENABLE_DEBUG_TOOLS';
var DEBUG_TOOL_TOGGLE = exports.DEBUG_TOOL_TOGGLE = 'TOGGLE_DEBUG_TOOL';

var DEBUG_LOCAL_STORAGE_KEY = exports.DEBUG_LOCAL_STORAGE_KEY = 'milanote.debug';


//////////////////
// WEBPACK FOOTER
// ./src/client/debug/debugConstants.js
// module id = 298
// module chunks = 0